import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const META_PIXEL_ID = '930387589738496'

let pixelInitialized = false

function initPixel() {
  if (pixelInitialized) return
  pixelInitialized = true

  const f = window as any
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement(e) as HTMLScriptElement
  t.async = true
  t.src = v
  ;(b.head || b.documentElement).appendChild(t)

  window.fbq('init', META_PIXEL_ID)
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (window.fbq) {
    if (params) {
      window.fbq('track', eventName, params)
    } else {
      window.fbq('track', eventName)
    }
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
    trackEvent('PageView')
  }, [])
}
